<!-- @format -->

<template>
  <a-modal
    :destroyOnClose="true"
    centered
    width="1080px"
    title="车辆变更"
    :visible="visible"
    @ok="handleSubmit"
    @cancel="$emit('cancel')"
  >
    <modal-config>
      <a-spin :spinning="spinning">
        <h4>
          车位信息
        </h4>
        <FieldInfoList
          v-if="cBasicInfo"
          :label-width="80"
          :column="3"
          :data="parentNode.detailModel"
          :fields="cBasicInfo"
        ></FieldInfoList>
        <h4 class="mt20">
          车辆信息<span style="color:#aaa;margin-left:10px" v-show="masterSlave == '01'"
            >(若需设置主车优先，请在对应车牌前打勾，点击保存后方可生效)</span
          >
        </h4>
        <div width="100%">
          <a-form ref="myForm" :form="form" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18 }">
            <div
              v-for="(k, index) in form.getFieldValue('keys')"
              :key="k"
              v-bind="index === 0 ? formItemLayout : formItemLayoutWithOutLabel"
            >
              <a-row>
                <div class="check-boox-div flex-div" v-show="masterSlave == '01'">
                  <a-form-item label="">
                    <a-checkbox :checked="models[index].checked" @change="handleCheck($event, index)"> </a-checkbox>
                  </a-form-item>
                </div>
                <div class="flex-div" style="width:300px">
                  <a-form-item label="车牌号">
                    <!-- {{index}} -->
                    <div style="padding-top:4px">
                      <PlateInput
                        :default-plate="models[index].plate"
                        :params="{ index: index }"
                        v-decorator="[
                          `plate${index}`,
                          {
                            rules: [
                              {
                                required: false,
                                message: '请输入车牌号',
                                pattern: /(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领临民]{1}[A-HJ-NP-Z0-9\u4e00-\u9fa5]{6,7}$)|(^[A-HJ-NP-Z]{1}[A-HJ-NP-Z0-9\u4e00-\u9fa5]{6,8}$)/
                              }
                            ]
                          }
                        ]"
                        @plateChange="handlePlateChange"
                      />
                    </div>

                    <!--            <a-input defaultValue="222" />-->
                  </a-form-item>
                </div>
                <div class="flex-div" style="width:200px">
                  <a-form-item label="车型">
                    <a-select v-model="models[index].carType">
                      <a-select-option value="01">小型车</a-select-option>
                      <a-select-option value="02">大型车</a-select-option>
                    </a-select>
                  </a-form-item>
                </div>
                <div class="flex-div" style="width:200px">
                  <a-form-item label="品牌">
                    <a-input v-model="models[index].brand" :maxLength="50" />
                  </a-form-item>
                </div>
                <div class="flex-div" style="width:200px">
                  <a-form-item label="颜色">
                    <a-input v-model="models[index].color" :maxLength="20" />
                  </a-form-item>
                </div>
                <div class="flex-div" style="width:60px">
                  <a-icon
                    v-if="form.getFieldValue('keys').length > 1"
                    class="dynamic-delete-button"
                    type="minus-circle-o"
                    :disabled="form.getFieldValue('keys').length === 1"
                    @click="() => remove(k, index)"
                  />
                </div>
              </a-row>
            </div>
            <div style="margin-left:40px;">
              <a-button @click="add(null)">
                <a-icon type="plus" />
                添加车牌
              </a-button>
            </div>
          </a-form>
        </div>
      </a-spin>
    </modal-config>
  </a-modal>
</template>

<script>
/** @format */
import PlateInput from '../../../components/plate-input/index.vue';
import { IForm } from '@/views/parking-lot-management/device-list/components/add-device-form';
import * as _ from 'lodash';
import {
  commitModifyCar,
  quertMonthCardDetail,
  orderEnterPlate,
  monthCardCheckOut
} from '../../../api/fixed-car-management/index';
import ModalConfig from '@/components/modal-config/index.vue';
let id = 0;

function closest(el, selector) {
  var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

  while (el) {
    if (matchesSelector.call(el, selector)) {
      break;
    }
    el = el.parentElement;
  }
  return el;
}

export default {
  props: {
    visible: Boolean,
    parentNode: Object,
    type: Boolean
  },

  components: {
    PlateInput,
    ModalConfig
  },
  data() {
    return {
      defaultPlate: '',
      models: [] || {
        plate: this.defaultPlate.plateHead || '',
        carType: '01',
        brand: '',
        color: '',
        checked: false,
        masterCar: '00'
      },
      cBasicInfo: null,
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 }
        }
      },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 }
        }
      },
      spinning: false,
      masterSlave: '00',
      spaceNum: 0,
      parkingNum: 0
    };
  },

  mounted() {
    const basicInfoFieldsConfig = _.cloneDeep(this.parentNode.basicInfo),
      codeIndex = basicInfoFieldsConfig.findIndex(item => item.prop == 'code');
    if (codeIndex > -1) {
      basicInfoFieldsConfig[codeIndex].render = (h, params) => {
        const { code = '' } = params.data;
        return h(
          'a-tooltip',
          {
            attrs: {
              placement: 'topLeft',
              title: code
            }
          },
          [
            h(
              'div',
              {
                class: 'text-ellipse',
                attrs: {
                  style: 'width:120px'
                }
              },
              code || '-'
            )
          ]
        );
      };
    }
    this.cBasicInfo = basicInfoFieldsConfig;
    this.getPlateList();
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'dynamic_form_item' });
    this.form.getFieldDecorator('keys', { initialValue: [], preserve: true });
  },
  methods: {
    //遍历授权车辆 取消主车
    cancelMaster() {
      for (let i = 0; i < this.models.length; i++) {
        this.models[i].checked = false;
        this.models[i].masterCar = '00';
      }
    },
    //详情
    async getPlateList() {
      try {
        this.spinning = true;
        const detail = await quertMonthCardDetail({
          cardId: this.parentNode.detailModel.cardId
        });
        this.defaultPlate = detail.data.plateHead || '';
        this.masterSlave = detail.data.masterSlave || '00';
        this.parkingNum = Number(detail.data.parkingNum) || 0;
        detail.data.plateList.forEach((model, index) => {
          const json = model;
          json.checked = model.masterCar == '01';
          this.add(model);
          this.form.setFieldsValue({
            ['plate' + index]: model.plate
          });
        });
      } catch (e) {
        console.log(e);
      } finally {
        this.spinning = false;
      }
    },
    handleCheck(e, index) {
      this.models[index].checked = e.target.checked;
      console.log(this.getCheckedNum());
      console.log(this.parkingNum);
      if (this.getCheckedNum() > this.parkingNum) {
        this.$nextTick(() => {
          this.$set(this.models[index], 'checked', false);
        });
        this.models[index].masterCar = this.models[index].checked ? '01' : '00';
        const typeMsg = this.type ? '月卡' : '产权车';
        return this.$message.error(`最多勾选的主车数量不得超过${typeMsg}的泊车数量`);
      }
      this.models[index].masterCar = this.models[index].checked ? '01' : '00';
      this.$message.success(
        e.target.checked
          ? '主车设置成功，若车辆已在场，则下次进场时生效'
          : '主车取消成功，若车辆已在场，则下次进场时生效。',
        1
      );
    },
    //获取勾选的主车个数
    getCheckedNum() {
      let count = 0;
      for (var i = 0; i < this.models.length; i++) {
        if (this.models[i].checked) count++;
      }
      return count;
    },
    //确定提交
    async handleSubmit() {
      const formData = await this.getFormValue();
      console.log(formData, '///////////');
      const platecopy = [];
      for (let i = 0; i < formData.length; i++) {
        platecopy.push(formData[i].plate);
      }
      // if (platecopy.length > 1) {
      //   for (let j = 0; j < platecopy.length; j++) {
      //     if (platecopy.indexOf(platecopy[j]) !== -1) {
      //       return this.$message.error('车牌号不能重复')
      //     }
      //   }
      // }

      function isUniqueArr(arrs) {
        for (let j = 0; j < arrs.length; j++) {
          if (arrs[j] === '') {
            delete arrs[j];
          }
        }
        let arrToStr = arrs.join(',') + ',';
        for (let i = 0; i < arrs.length; i++) {
          //ps:替换为空，还能发现元素，证明有重复元素
          if (arrToStr.replace(arrs[i] + ',', '').indexOf(arrs[i] + ',') > -1) {
            console.log('数组中有重复元素：' + arrs[i]);
            return false;
          }
        }
        return true;
      }
      isUniqueArr(platecopy);
      if (!isUniqueArr(platecopy)) return this.$message.error('车牌号不能重复');
      console.log(this.models, '0----------------->>>>>');

      console.log(isUniqueArr(platecopy));
      const json = {
        parkId: this.parentNode.detailModel.parkId,
        cardId: this.parentNode.detailModel.cardId,
        plateList: formData
      };
      const _self = this;
      try {
        this.spinning = true;
        const { data } = await monthCardCheckOut(json);
        this.spinning = false;
        if (data) {
          this.$confirm({
            title: '提示',
            content: data,
            onOk() {
              _self.toSave(formData);
            },
            onCancel() {}
          });
        } else {
          _self.toSave(formData);
        }
      } catch (error) {
        _self.$message.error(error.msg || '系统繁忙，请稍后再试');
      } finally {
        this.spinning = false;
      }
    },
    //去保存
    async toSave(formData) {
      let formDataplate = formData;
      // 找到车牌为空的
      if (formDataplate.length > 0) {
        formDataplate = formDataplate.filter(item => item.plate !== '');
      }

      try {
        this.spinning = true;
        await commitModifyCar({
          plateList: formDataplate,
          parkId: this.parentNode.detailModel.parkId,
          cardId: this.parentNode.detailModel.cardId
        });
        this.$message.success('车辆变更成功');
        this.parentNode.fetchTableData();
        this.$emit('ok');
      } catch (error) {
        this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      } finally {
        this.spinning = false;
      }
    },
    validate(cb) {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          cb(values);
        }
      });
    },
    //改变车牌
    handlePlateChange([head, tail], p) {
      head = head || '';
      tail = tail || '';
      try {
        const index = p.index;
        this.models[index].plate = head + tail;
        this.form.setFieldsValue({
          ['plate' + index]: head + tail
        });
      } catch (e) {
        console.warn('e--', e);
        void 0;
      }
    },
    //删除
    async remove(k, index) {
      const { form } = this;
      const keys = form.getFieldValue('keys');
      if (keys.length === 1) {
        return;
      }
      const plateName = this.models[index].plate;
      if (plateName) {
        try {
          this.spinning = true;
          const json = {
            parkId: this.parentNode.detailModel.parkId,
            plate: plateName
          };
          const { data } = await orderEnterPlate(json);
          this.spinning = false;
          this.nextRemove(form, keys, index, k);
        } catch (error) {
          this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
          this.spinning = false;
        }
      } else {
        this.nextRemove(form, keys, index, k);
      }
      // form.setFieldsValue({
      //   keys: keys.filter(key => key !== k).map((v, mapIndex) => mapIndex),
      // })
      // this.models.splice(index, 1)
      // this.models.forEach((item, index1) => {
      //   form.setFieldsValue({
      //     ['plate' + index1]: item.plate,
      //   })
      // })
    },
    nextRemove(form, keys, index, k) {
      form.setFieldsValue({
        keys: keys.filter(key => key !== k).map((v, mapIndex) => mapIndex)
      });
      this.models.splice(index, 1);
      this.models.forEach((item, index1) => {
        form.setFieldsValue({
          ['plate' + index1]: item.plate
        });
      });
    },

    modelAdd(model) {
      this.models.push(
        model || {
          plate: this.defaultPlate.plateHead || '',
          carType: '01',
          brand: '',
          color: '',
          checked: false,
          masterCar: '00'
        }
      );
      if (this.masterSlave == '00') {
        this.cancelMaster();
      }
    },
    modelRemove() {},
    getFormValue() {
      return new Promise((resolve, reject) => {
        if (this.models.length == 0) {
          return this.$message.error('车牌列表不能为空');
        }
        console.log(this.models, '----------000000--------');

        const typeMsg = this.type ? '月卡' : '产权车';
        // console.log(this.getCheckedNum())
        if (this.getCheckedNum() > this.parkingNum)
          return this.$message.error(`最多勾选的主车数量不得超过${typeMsg}的泊车数量`);
        this.validate(values => {
          let hasError = false;
          this.models.forEach((model, index) => {
            if (model.plate.length >= 1 && !new RegExp('^[\u4e00-\u9fa5]').test(model.plate)) {
              hasError = true;
              const rowNo = index + 1;
              this.$message.error('车辆信息第' + rowNo + '行：请输入完整且格式合法的车牌号');
            }
          });
          if (!hasError) {
            resolve(this.models);
          }
        });
      });
    },
    add(model = null) {
      const { form } = this;
      const keys = form.getFieldValue('keys');
      const nextKeys = keys.concat(id++);
      form.setFieldsValue({
        keys: nextKeys.map((v, mapIndex) => mapIndex)
      });
      this.modelAdd(model);
    }
  }
};
</script>
<style>
/** @format */

.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}

.dynamic-delete-button:hover {
  color: #777;
}

.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
.inline-block {
  display: inline-block;
}
.check-boox-div {
  width: 40px;
}
.flex-div {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  float: left;
}
</style>
